import './init-nav';
import './init-aos';
if (document.querySelector('.js-license-tiers')) {
    import('./init-license-tiers');
}
if (document.querySelector('pre')) {
    import('./init-highlight-code');
}
if (document.querySelector('.js-agenda-accordion')) {
    import('./init-agenda');
}
if (document.querySelector('.js-soty-voting')) {
    import('./init-soty-voting');
}
if (document.querySelector('.js-xpcookiebanner')) {
    import('./init-cookie-banner');
}
if (document.querySelector('.js-cookie-preferences')) {
    import('./init-cookie-preferences');
}
if (document.querySelector('.js-count-up')) {
    import('./init-countup');
}
if (document.querySelector('.js-smoothscroll-link')) {
    import('./init-smoothscroll');
}
if (document.querySelector('.js-subnav')) {
    import('./init-subnav');
}
if (document.querySelector('.js-course-carousel')) {
    import('./init-carousel-course');
}
if (document.querySelector('.js-event-carousel')) {
    import('./init-carousel-event');
}
if (document.querySelector('.js-testimonial-carousel')) {
    import('./init-carousel-testimonial');
}
if (document.querySelector('.js-tabbed-section')) {
    import('./init-tabbed-section');
}
if (document.querySelector('.js-tabbed-section-connected')) {
    import('./init-tabbed-section-connected');
}
if (document.querySelector('.js-tabbed-feature-title')) {
    import('./init-tabbed-features');
}
if (document.querySelector('.js-accordion')) {
    import('./init-accordion');
}
if (document.querySelector('.js-video-card')) {
    import('./init-video-card');
}
if (document.querySelector('.js-tabbed-media')) {
    import('./init-tabbed-media');
}
if (document.querySelector('.js-share-btn')) {
    import('./init-share-button');
}
if (document.querySelector('.js-bizform')) {
    import('./init-bizform');
}
if (document.querySelector('.js-projects-load-more')) {
    import('./init-projects-loadmore');
}
if (document.querySelector('.js-lightbox') ||
    document.querySelectorAll('.js-lightbox-individual img').length) {
    import('./init-lightbox');
}
if (document.querySelector('.js-header--xpcookiebanner-is-active')) {
    import('./init-cookie-banner-lightbox');
}
if (document.querySelector('table')) {
    import('./init-tables');
}
if (document.querySelector('[data-autoplay]')) {
    import('./init-video-autoplay');
}
